import React__default from 'react';
import { useFormContext } from 'react-hook-form';
import { jsx } from '@emotion/react';
import { FileUploadField } from '@bucketplace/commerce-admin-ui';
import '../../../contexts/internal/StickyContext.js';
import '../../../contexts/internal/EditorContext.js';
import { useEditorInfoContext } from '../../../contexts/external/EditorInfoContext.js';
import { LottiePreview } from './LottiePreview.js';

function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
var PATH = 'uploads/exhibitions/contents/contest_description';
var DEFAULT_LIMIT = 10 * 1024;
var ACCEPT = '.json';
function LottieUploadField(_ref) {
  var name = _ref.name;
  var _useEditorInfoContext = useEditorInfoContext(),
    uploadEndpoint = _useEditorInfoContext.uploadEndpoint;
  var _useFormContext = useFormContext(),
    watch = _useFormContext.watch;
  var files = watch(name);
  return jsx(React__default.Fragment, null, !(files !== null && files !== void 0 && files.length) ? jsx(FileUploadField, {
    name: name,
    endpoint: uploadEndpoint,
    path: PATH,
    accept: ACCEPT,
    isPrivateFile: false,
    fileLimitSize: DEFAULT_LIMIT,
    useArrayType: false,
    serializer: {
      serialize: function serialize(url) {
        return {
          url: url
        };
      },
      deserialize: function deserialize(data) {
        return data.url;
      }
    },
    customCss: FileUploadFieldCss
  }) : jsx(LottiePreview, {
    name: name
  }));
}
var FileUploadFieldCss = process.env.NODE_ENV === "production" ? {
  name: "11rcwxl",
  styles: "margin-bottom:4px"
} : {
  name: "12hxiz9-FileUploadFieldCss",
  styles: "margin-bottom:4px;label:FileUploadFieldCss;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
};

export { LottieUploadField };
//# sourceMappingURL=LottieUploadField.js.map
